import Seo from "../components/Seo";
import PageHeader from "../components/PageHeader";
import ShopCard, { ShopsEmpty } from "../components/ShopCard";
import ShopsMap from "../components/ShopsMap";
import { Reveal } from "../components/Motion";
import { Skeleton } from "../components/ui/skeleton";
import { useShops } from "../lib/useShops";

export default function Shops() {
  const shops = useShops();
  const list = shops ?? [];
  return (
    <>
      <Seo title="Our Locations — MHM SUPER ADBLUE Shops" description="Find MHM SUPER ADBLUE shops near you. Shop photos, addresses and Google Maps directions for every MHM SUPER ADBLUE outlet." />
      <PageHeader testid="shops-header" eyebrow="Our locations" lines={["Find an MHM", { text: "Super AdBlue shop.", cls: "text-brand" }]} intro="Visit any of our shops for AdBlue and lubricating oils. Tap a shop for directions on Google Maps." />
      <section className="bg-[var(--paper)] py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          {list.some((s) => typeof s.lat === "number") && (
            <Reveal className="mb-14">
              <ShopsMap shops={list} height="h-[380px] md:h-[520px]" />
            </Reveal>
          )}
          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
            <h2 data-testid="shops-heading" className="font-display text-4xl md:text-5xl font-extrabold uppercase text-navy">Our shop locations <span className="text-brand">–</span> MHM Super AdBlue</h2>
            {shops && <p data-testid="shops-count" className="font-mono text-sm text-slate-500">{list.length} {list.length === 1 ? "shop" : "shops"}</p>}
          </div>
          <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {shops === null && [0, 1, 2].map((i) => <Skeleton key={i} className="h-[440px] rounded-[22px]" />)}
            {list.map((s, i) => <ShopCard key={s.id} s={s} index={i} />)}
          </div>
          {shops && list.length === 0 && <ShopsEmpty />}
        </div>
      </section>
    </>
  );
}
